// src/components/SideNav.js
import React from 'react';
import { ArrowLeft, ArrowRight } from "react-feather";
import Navigation from "./Navigation";
import User from "./User";
import VisActor from "./VisActor";

export default function SideNav({ isOpen, onToggle, activeTab, setActiveTab, filingStatus, userName, onOpenModal, onReady }) {
  
  // New handler to close menu on mobile when a tab is clicked
  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    if (window.innerWidth <= 768) {
      onToggle(); // Close the menu
    }
  };

  return (
    <>
      <button
        className={`mobile-toggle ${isOpen ? "is-open" : ""}`}
        onClick={onToggle}
        aria-label="Toggle Menu"
      >
        {isOpen ? <ArrowLeft size={20} /> : <ArrowRight size={20} />}
      </button>
      
      {/* Add overlay for clicking outside to close */}
      {isOpen && (
        <div 
          className="sidebar-overlay" 
          onClick={onToggle}
          style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 39
          }} 
        />
      )}

      <aside className={`sidebar-nav ${isOpen ? "is-open" : ""}`}>
        <User name={userName} filingStatus={filingStatus} onOpenModal={onOpenModal} />

        {/* ADD THIS BLOCK UNDER USER */}
  <div style={{ padding: '10px 15px', borderBottom: '1px solid #e7e5e4' }}>
    <div style={{ fontSize: '0.75rem', color: '#78716c', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '5px' }}>
      Current Plan
    </div>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <span style={{ fontWeight: 'bold', color: '#473d2a' }}>Free Estimator</span>
      <span style={{ fontSize: '0.8rem', backgroundColor: '#e7e5e4', padding: '2px 6px', borderRadius: '4px' }}>
        File: $19
      </span>
    </div>
  </div>
        
        {/* Pass the new handler to Navigation */}
        <div className="sidebar-links">
            {/* We need to modify Navigation.js slightly or map here. 
                Since Navigation.js is simple, let's just pass the custom handler logic 
                by wrapping the setActiveTab prop if possible, or modifying Navigation.js.
                
                Let's modify Navigation.js below to accept an onLinkClick prop.
            */}
            <Navigation activeTab={activeTab} setActiveTab={handleTabClick} />
        </div>

        <VisActor onReady={() => {
            onReady();
            if (window.innerWidth <= 768) onToggle();
        }} />
      </aside>
    </>
  );
}